const menu        = require('../../../../../components/menu/menu')
const dtHandler   = require('../../../../../components/dt/dt-handler')


export function start( detail, htmlDt, htmlFc ){  //console.log('clientActivity-menu  >', detail)

  const menuElem = menuBody[detail.id]

  for(let i=0; i< menuElem.length; i++){
        menuElem[i].start(detail, htmlDt, htmlFc)
  }  

  detail.html = menuElem
  detail.act  = 'show'
  menu.start(detail)

}

const menuBody = {

  trMenu: [

      { text: '', 
        svg:'eye', 
        class:``,
        dataDetail:``,
        
        start: function(detail){  
          this.text   = 'View/Edit'        //language.start('inProgress')     
          this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              { "dest":"clientActivity", "elem":"fullcont", "id":"clientActivity-fullcont", "act":"selectOne",  "entity":"clientActivity", "dbid": ${detail.dbid} }
           ]}'`

        }
      },   

      { text: '', 
        svg:'report', 
        class:``, //same name as the title test

        dataDetail: '',

        start: function(detail){  
          this.text   = 'Purchase Report'        //language.start('inProgress')
          this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"clientActivity", "elem":"report", "reportType":"reportOne", "entity":"clientActivity", "dbid":"${detail.dbid}", "source":"dt" } 

        ]}'`
        
        }

      },
      
      { text: '', 
        svg:'print', 
        class:``, //same name as the title test

        dataDetail: '',

        start: function(detail){  
          this.text   = 'Print Order'        //language.start('inProgress')
          this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"clientActivity", "elem":"fullcont", "id":"clientActivity-fullcont", "act":"clientActivityPrintPdf", "id":"${detail.dbid}"} 

        ]}'`
        
        }

      },
          
      { text: '', 
        svg:'barcode', 
        class:``, //same name as the title test
        dataDetail:``,

        start: function(detail, htmlDt, htmlFc){  

              //if exist one check
                  this.class  = ``
                  this.text   = `Print Label`                 
                  this.dataDetail = `data-detail='{
                                    "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"clientActivity", "elem":"fullcont", "id":"clientActivity-fullcont", "act":"printlabeldt", "dbid":"${detail.dbid}"}  ]}'`             
            }/**/
      },

     {text:'line', start: function(){}}, //////////////line

      { text: '', 
        svg:'delete', 
        class:``,
        dataDetail:`data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}
        ]}'`,
        
        start: function(detail){  

          this.text   = 'Delete'        //language.start('inProgress')     
          this.dataDetail = `data-detail='{
                            "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"clientActivity", "elem":"fullcont", "act":"deleteEntity", "entity":"clientActivity", "dbid":["${detail.dbid}"] } 
           ]}'`

        }
      },
   ],

  
    tableOptions: [
       
        { text: '', 
          svg:'print', 
          class:``, //same name as the title test
  
          dataDetail:`data-detail='{
                            "click": [
                                {"dest":"ripple" },
                                {"dest":"menu", "act":"hide"},
                                {"dest":"clientActivity", "elem":"report", "reportType":"accountReceivable"}
          ]}'`,
  
  
          start: function(){  
            this.text   = 'Account Receivable'        //language.start('inProgress')     
          }
        },
  
        { text: '', 
          svg:'print', 
          class:``, //same name as the title test
  
          dataDetail:`data-detail='{
                            "click": [
                                {"dest":"ripple" },
                                {"dest":"menu", "act":"hide"},
                                {"dest":"clientActivity", "elem":"report", "reportType":"accountPayable"}
          ]}'`,
  
  
          start: function(){  
            this.text   = 'Account Payable'        //language.start('inProgress')     
          }
        },
       
    ],


  fullcontOptions: [

      { text: '', 
        svg:'edit', 
        class:``, //same name as the title test
        dataDetail:``,

        start: function(detail, htmlDt, htmlFc){  
                this.text   = `Lost`                 
                this.dataDetail = `data-detail='{
                                   "click": [
                                      {"dest":"ripple" },
                                      {"dest":"menu", "act":"hide"},
                                      {"dest":"fullcont", "id":"clientActivity-fullcont", "act":"NoTabSource", "pagetoshow":"lost" } ]}'`             
            }/**/
      },

      { text: '', 
        svg:'print', 
        class:``, //same name as the title test
        dataDetail:``,

        start: function(detail, htmlDt, htmlFc){  

              //if exist one check
                  this.class  = ``
                  this.text   = `Print Order`                 
                  this.dataDetail = `data-detail='{
                                     "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"clientActivity", "elem":"fullcont", "id":"clientActivity-fullcont", "act":"clientActivityPrintPdf", "id":""} ]}'`             
            }/**/
      },

        
      { text: '', 
        svg:'print', 
        class:``, //same name as the title test
        dataDetail:``,

        start: function(detail, htmlDt, htmlFc){  

              //if exist one check
                  this.class  = ``
                  this.text   = `Print Label`                 
                  this.dataDetail = `data-detail='{
                                    "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"clientActivity", "elem":"fullcont", "act":"printlabel"} ]}'`             
            }/**/
      },


      { text: '', 
        svg:'report', 
        class:``, //same name as the title test
        dataDetail:``,

        start: function(detail, htmlDt, htmlFc){  

              //if exist one check
                  this.class  = ``
                  this.text   = `Purchase Report`                 
                  this.dataDetail = `data-detail='{
                                     "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"clientActivity", "elem":"report", "reportType":"reportOne", "source":"fullcont"} ]}'`             
            }/**/
      },

     {text:'line', start: function(){}}, //////////////line
     
      { text: '', 
        svg:'delete', 
        class:``, //same name as the title test

        dataDetail:``,

          start: function(detail, htmlDt, htmlFc){  

            const dbid = htmlFc.fullcontHTML.getAttribute('data-dbid')

              //if exist one check
                  this.class  = ``
                  this.text   = `Delete `                 
                  this.dataDetail = `data-detail='{
                                    "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"clientActivity", "elem":"fullcont", "act":"deleteEntity", "entity":"clientActivity",  "dbid":[${dbid}]} ]}'`             
              
            }/**/
      },

  ],

}/*menuBody*/


